import ConsultingIcon from '../icons/ConsultingIcon/ConsultingIcon.svg';
import CreateIcon from '../icons/CreateIcon/CreateIcon.svg';
import CareIcon from '../icons/CareIcon/CareIcon.svg';
import MeatingIcon from '../icons/MeatingIcon/MeatingIcon.svg';
import PresentationIcon from '../icons/PresentationIcon/PresentationIcon.svg';
import SignIcon from '../icons/SignIcon/SignIcon.svg';
import BuildingIcon from '../icons/BuildingIcon/BuildingIcon.svg';
import PhoningIcon from '../icons/PhoningIcon/phoning.svg';

const loansData = [
  {
    id: '1',
    title: 'Ověření a dohled',
    text: 'Ověření možností refinancování dle původních smluv a následný dohled nad včasnou přípravnou refinancování.',
    icon: PhoningIcon,
  },
  {
    id: '2',
    title: 'Schůzka',
    text: 'Vysvětlení principů spolupráce s JHavel Finance, vysvětlení průběhu refinancování.',
    icon: MeatingIcon,
  },
  {
    id: '3',
    title: 'Projednání záměru',
    text: 'Projednání a následné stanovení základních parametrů, jako je výše úvěru, splatnost, délka fixace úrokové sazby atd. ',
    icon: ConsultingIcon,
  },
  {
    id: '4',
    title: 'Pověření JHavel Finance',
    text: 'Pověření JHavel Finance k zajištění nabídek od jednotlivých institucí.',
    icon: SignIcon,
  },
  {
    id: '5',
    title: 'Příprava nabídek',
    text: 'Příprava nabídek od všech institucí dle stanovených parametrů, úprava dle požadavků klienta. ',
    icon: CreateIcon,
  },
  {
    id: '6',
    title: 'Vyhodnocení a doporučení nabídek',
    text: 'Předání všech finálních nabídek a doporučení ze strany JHavel Finance.',
    icon: PresentationIcon,
  },
  {
    id: '7',
    title: 'Podpis smluv',
    text: 'Zajištění podpisů smluv s refinancující institucí.',
    icon: SignIcon,
  },
  {
    id: '8',
    title: 'Spolupráce při refinancování',
    text: '  Spolupráce při samotném refinancování úvěru, komunikace s partnery a předání potřebných dokumentů.  ',
    icon: BuildingIcon,
  },
  {
    id: '9',
    title: 'Péče v období splácení úvěru',
    text: 'Průběžná péče o klienta.',
    icon: CareIcon,
  },
];

export default loansData;
